'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
interface RailCarouselArrowsProps {
  arrowPosition: {
    vertical: number;
  };
  previousSlide: (args: any) => void;
  nextSlide: (args: any) => void;
  hideLeft: boolean;
  hideRight: boolean;
}
export const RailCarouselArrows = t0 => {
  const $ = _c(34);
  const {
    arrowPosition,
    previousSlide,
    nextSlide,
    hideLeft,
    hideRight
  } = t0;
  const {
    t
  } = useLocale("carousel");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== arrowPosition.vertical || $[1] !== hideLeft || $[2] !== nextSlide || $[3] !== previousSlide || $[4] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const commonClasses = ["[--arrow-size:40px] lg:[--arrow-offset-x:6px] xl:[--arrow-offset-x:12px]", "flex items-center justify-center bg-white absolute z-10 flex size-(--arrow-size) shrink-0 rounded-full shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl"];
      if (arrowPosition.vertical === 0) {
        t6 = null;
        break bb0;
      }
      t4 = "hidden lg:block";
      let t7;
      if ($[11] !== t) {
        t7 = t("previous-slide");
        $[11] = t;
        $[12] = t7;
      } else {
        t7 = $[12];
      }
      const t8 = hideLeft ? 0 : 1;
      const t9 = hideLeft ? "hidden" : "visible";
      let t10;
      if ($[13] !== arrowPosition.vertical || $[14] !== t8 || $[15] !== t9) {
        t10 = {
          top: arrowPosition.vertical,
          left: "calc(-1 * var(--arrow-size) - var(--arrow-offset-x))",
          opacity: t8,
          visibility: t9
        };
        $[13] = arrowPosition.vertical;
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
      } else {
        t10 = $[16];
      }
      let t11;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = <ChevronLeftIcon className="size-8 text-black" />;
        $[17] = t11;
      } else {
        t11 = $[17];
      }
      t5 = <button onClick={previousSlide} aria-label={t7} className={cn(commonClasses)} style={t10}>{t11}</button>;
      t1 = nextSlide;
      if ($[18] !== t) {
        t2 = t("next-slide");
        $[18] = t;
        $[19] = t2;
      } else {
        t2 = $[19];
      }
      t3 = cn(commonClasses);
    }
    $[0] = arrowPosition.vertical;
    $[1] = hideLeft;
    $[2] = nextSlide;
    $[3] = previousSlide;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  const t7 = hideRight ? 0 : 1;
  const t8 = hideRight ? "hidden" : "visible";
  let t9;
  if ($[20] !== arrowPosition.vertical || $[21] !== t7 || $[22] !== t8) {
    t9 = {
      top: arrowPosition.vertical,
      right: "calc(-1 * var(--arrow-size) - var(--arrow-offset-x))",
      opacity: t7,
      visibility: t8
    };
    $[20] = arrowPosition.vertical;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronRightIcon className="size-8 text-black" />;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t9) {
    t11 = <button onClick={t1} aria-label={t2} className={t3} style={t9}>{t10}</button>;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t4 || $[32] !== t5) {
    t12 = <div className={t4}>{t5}{t11}</div>;
    $[30] = t11;
    $[31] = t4;
    $[32] = t5;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};